import ChevronLeft from './ChevronLeft';
import GameHeaderButton from '../GameHeaderButton';

type Props = {
  onClick?: () => void;
  className?: string;
};

const BackButton: FC<Props> = ({ onClick, className }) => (
  <GameHeaderButton onClick={onClick} className={className}>
    <ChevronLeft />
  </GameHeaderButton>
);

export default BackButton;
